import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { FormPanelProps, FormSwitch, FormTextField } from "./formFields";

interface Props extends FormPanelProps {
  lastAccessDate?: string | Date | null;
}

export function UserTab({ form, setField, isMobile, lastAccessDate }: Props) {
  const { t } = useTranslation();
  const direction = isMobile ? "column" : "row";
  const bind = { form, setField };
  return (
    <Stack spacing={1.25}>
      <Stack direction={direction} spacing={1.25}>
        <FormTextField {...bind} field="name" label={t("users.email")} />
        <FormSwitch {...bind} field="isDriver" label={t("users.isDriver")} />
      </Stack>
      <Stack direction={direction} spacing={1.25}>
        <FormTextField {...bind} field="firstName" label={t("users.firstName")} />
        <FormTextField {...bind} field="lastName" label={t("users.lastName")} />
      </Stack>
      <Stack direction={direction} spacing={1.25}>
        <FormTextField {...bind} field="designation" label={t("users.designation")} />
        <FormTextField {...bind} field="employeeNo" label={t("users.employeeNo")} />
      </Stack>
      <Stack direction={direction} spacing={1.25}>
        <FormTextField {...bind} field="phoneNumber" label={t("users.phone")} />
        <FormTextField {...bind} field="phoneExt" label={t("users.phoneExt")} />
      </Stack>
      <Stack direction={direction} spacing={1.25}>
        <FormTextField {...bind} field="companyName" label={t("users.companyName")} />
        <FormTextField {...bind} field="countryCode" label={t("users.countryCode")} />
      </Stack>
      <FormTextField {...bind} field="companyAddress" label={t("users.companyAddress")} />
      <FormTextField {...bind} field="comment" label={t("users.comment")} multiline minRows={3} />
      {lastAccessDate ? (
        <Typography variant="caption" color="text.secondary">
          {t("users.lastAccess")}: {new Date(lastAccessDate).toLocaleString()}
        </Typography>
      ) : null}
    </Stack>
  );
}
